<template>
    <div class="radio-group-wrapper" :class="{ 'radio-group-disabled': disabled }">
        <Radio
            class="group-radio"
            v-for="(radio, idx) in radios"
            :key="idx"
            :data="radio"
            :space="space"
            :beteewn="beteewn"
            :checked="current === radio.value"
            @change="radioClick(radio)"
        />
    </div>
</template>

<script>
import Radio from "./Radio";

export default {
    name: "RadioGroup",
    components: {
        Radio
    },
    props: ["radios", "space", "beteewn", "disabled"],
    data() {
        return {
            current: this.getCurrent()
        };
    },
    watch: {
        radios() {
            this.current = this.getCurrent();
        }
    },
    methods: {
        radioClick(radio) {
            if (this.disabled) {
                return;
            }

            this.current = radio.value;
            this.$emit("change", this.current);
        },
        getCurrent() {
            let cur = "";

            this.radios.some(radio => {
                if (radio.checked) {
                    cur = radio.value;
                    return true;
                }
            });

            return cur;
        }
    }
};
</script>

<style lang="scss" scoped>
.radio-group-wrapper {
    display: inline-block;
    .group-radio:last-child {
        margin-right: 0 !important;
    }

    &.radio-group-disabled {
        filter: grayscale(1);
    }
}
</style>
